"use client";

import React from "react";
import SidebarLayout from "./SidebarLayout";

interface LearningLayoutProps {
    children: React.ReactNode;
}

const LearningLayout: React.FC<LearningLayoutProps> = ({ children }) => {
    return (
        <SidebarLayout navTitle="Learning & Teaching" sidebarHeader="Learning & Teaching">
            {children}
        </SidebarLayout>
    );
};

export default LearningLayout;
